import { render, staticRenderFns } from "./add-position.vue?vue&type=template&id=ef3c0aa6&scoped=true"
import script from "./add-positon.ts?vue&type=script&lang=ts&external"
export * from "./add-positon.ts?vue&type=script&lang=ts&external"
import style0 from "./add-positon.scoped.scss?vue&type=style&index=0&id=ef3c0aa6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3c0aa6",
  null
  
)

export default component.exports